import {
  ArticleNewsIcon,
  NavHomeIcon,
  GroupIcon,
  SettingsIcon,
  PollIcon,
  ClipboardIcon,
  ApplicationIcon,
  NewWindowExternalLinkIcon,
  CirclePlusIcon,
} from '@pmi/dsm-react/dist/components/icons/fa/16';
import { NavItem } from '../../navigation/navigationRouting';

const iconDictionary = {
  article: () => (
    <ArticleNewsIcon fontSize="sm" color="original" className="sidebar-icon" />
  ),
  home: () => (
    <NavHomeIcon fontSize="sm" color="original" className="sidebar-icon" />
  ),
  people: () => (
    <GroupIcon fontSize="sm" color="original" className="sidebar-icon" />
  ),
  reports: () => (
    <PollIcon fontSize="sm" color="original" className="sidebar-icon" />
  ),
  orderHistory: () => (
    <ClipboardIcon fontSize="sm" color="original" className="sidebar-icon" />
  ),
  store: () => (
    <CirclePlusIcon fontSize="sm" color="original" className="sidebar-icon" />
  ),
  settings: () => (
    <SettingsIcon fontSize="sm" color="original" className="sidebar-icon" />
  ),
  logs: () => (
    <ApplicationIcon fontSize="sm" color="original" className="sidebar-icon" />
  ),
  newWindowExternalLink: () => (
    <NewWindowExternalLinkIcon
      fontSize="sm"
      color="original"
      className="sidebar-icon"
    />
  ),
};

const NestedConvert = (
  menus: NavItem[],
  prefix: string = 'parent',
  loop: number = 0,
) =>
  menus?.map((route: NavItem, index: number): NavItem => {
    const clone: NavItem = { ...route };
    clone.children = NestedConvert(
      clone?.children,
      `${'_'.repeat(loop)}child`,
      loop + 1,
    );
    return {
      ...clone,
      id: `${prefix}-${index + 1}`,
      icon:
        clone?.iconName?.length > 0 && iconDictionary[clone.iconName]
          ? iconDictionary[clone.iconName]()
          : null,
    };
  });

export default NestedConvert;
